import React from 'react';
import { Box, Flex } from '@adsk/alloy-react-box';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import { PRICING_URL, AUTOSPECS_TRIAL_MARKETING_URL, OFFERINGS_CATEGORIES } from './helpers/const';
import { buttonStyle } from './helpers/styles';
import { SUBSCRIPTION_STATUS } from '../../helpers/const';
import { subscriptionPropType } from '../../helpers/types';
const TrialModalItem = _ref => {
  let {
    userTrial
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../../i18n/".concat(locale, ".json"));
  });
  const {
    daysRemaining,
    offeringCategory,
    offeringCategoryName,
    status
  } = userTrial;
  const daysLeftText = daysRemaining > 1 ? T.translate('MODAL_ITEM_TEXT_EXPIRED_COUNT_MULTIPLE', {
    daysRemaining
  }) : T.translate('MODAL_ITEM_TEXT_EXPIRED_COUNT_SINGLE', {
    daysRemaining
  });
  return /*#__PURE__*/React.createElement(Flex, {
    paddingBottom: "16px",
    flexDirection: "row",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Box, {
    typography: "bodyMedium"
  }, offeringCategoryName), /*#__PURE__*/React.createElement(Box, {
    typography: "bodyMedium",
    color: daysRemaining !== null && daysRemaining < 3 ? 'red500' : 'charcoal900'
  }, status === SUBSCRIPTION_STATUS.ACTIVE ? daysLeftText : T.translate('MODAL_ITEM_TEXT_EXPIRED'))), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "TrialModalItem_button",
    as: "a",
    target: "_blank",
    href: offeringCategory === OFFERINGS_CATEGORIES.AUTOSPECS ? AUTOSPECS_TRIAL_MARKETING_URL : "".concat(PRICING_URL, "/").concat(offeringCategory),
    style: buttonStyle,
    variant: Button.VARIANTS.PRIMARY
  }, T.translate('MODAL_ITEM_TEXT_BUTTON_TEXT')));
};
TrialModalItem.displayName = 'TrialModalItem';
TrialModalItem.propTypes = {
  /** User Trial Data */
  userTrial: subscriptionPropType.isRequired
};
export default TrialModalItem;
//# sourceMappingURL=component.js.map